export const getDisplayLocation = (
  residentialAddress?: UserProfileLocation,
  isUkUser = false
): string => {
  const { city, state, country } = residentialAddress ?? {};
  if (!isUkUser) {
    const location = city && state ? `${city}, ${state}` : '';
    return location;
  }

  const location = city && country ? `${city}, ${country}` : '';
  return location;
};

export const getIsValidUkZipCode = (zipCode?: string): boolean => {
  if (!zipCode) return false;
  const noSpacesZipCode = zipCode.replace(/\s/g, '');
  return (
    noSpacesZipCode.length >= MIN_LENGTH_UK_ZIP_CODE_NO_SPACES &&
    noSpacesZipCode.length <= MAX_LENGTH_UK_ZIP_CODE_NO_SPACES
  );
};

export const MIN_LENGTH_UK_ZIP_CODE_NO_SPACES = 5;
const MAX_LENGTH_UK_ZIP_CODE_NO_SPACES = 7;
